import * as React from 'react'
import { lightTheme } from '@/customTheme'

/** Position "Custom" mode icon (Figma 12082:22401): frame with an offset inner square. */
function PositionCustomIcon({ size = 24, color = lightTheme.colors.blackGray }: { size?: number; color?: string }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="2" y="2" width="20" height="20" rx="2" stroke={color} strokeWidth="2" />
      <rect x="10" y="10" width="8" height="8" rx="1" stroke={color} strokeWidth="2" />
    </svg>
  )
}

export default PositionCustomIcon
